// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import { canUseDOM } from "exenv";

const MoblicoCookieKey = "MobileApp-isMoblico";

export function getIsMoblicoCookie() {
    return !!getCookie(MoblicoCookieKey);
}

export function setIsMoblicoCookieIfNeeded(isMoblico: string) {
    if (isMoblico === "1") {
        if (canUseDOM) {
            setCookie(MoblicoCookieKey, isMoblico);
        }
        return true;
    }
    return false;
}
